import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
// import EditQuoteForm from './modal/EditQuoteForm';
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../Config";
import { FocusError } from "focus-formik-error";
import Select from "react-select";
import * as Yup from "yup";
import { getTransportQuoteDetail, getTransporterList } from "../../Redux/action/Transport/TransportAction";
import { useSelector, useDispatch } from "react-redux";
const TransporterPreview = () => {
    const { b64id } = useParams();
    const dispatch = useDispatch()

    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    const validationSchema = Yup.object().shape({
        transporters: Yup.array()
            .min(1, "Please select at least one transporter.")  // Ensure the array has at least one item
            .required("Transporters are required."),  // Ensure the field is not empty
    });


    const {

        loadingTransporterList,
        transporterListDataError,
        transporterListData

    } = useSelector(state => state?.TransportReducer);

    const flexichain_user_id = Cookies.get('flexichain_user_id')
    useEffect(() => {
        dispatch(getTransporterList(token, flexichain_user_id));
    }, [adminMainUrl]);

    const [transporterOptions, setTransporterOptions] = useState([]);

    useEffect(() => {
        if (transporterListData) {
            let arr = transporterListData.map(val => ({
                value: val.id,
                label: val.company_name,
                email: val.email,  // Include email
                company_name: val.company_name, // Include company name
            }));
            setTransporterOptions(arr);
        }
    }, [loadingTransporterList, transporterListData]);


 

    const { loadingTransportQuoteDetail, transportQuoteDetailData, transportQuoteDetailDataError } = useSelector(state => state?.TransportReducer);



useEffect(() => {
    if (transportQuoteDetailData?.transporters) {
        let parsedTransporters = [];

        try {
            parsedTransporters = JSON.parse(transportQuoteDetailData.transporters);
        } catch (error) {
            console.error("Error parsing transporters:", error);
            return;
        }
      
        if (Array.isArray(parsedTransporters)) {
            const formattedOptions = parsedTransporters?.map(transporter => ({
                value: transporter.id,
                label: transporter.company_name,
                email: transporter.email,
                company_name: transporter.company_name,
            }));

            setTransporterOptions(formattedOptions);

            // ✅ Set Formik field only if it's empty to prevent overwriting user selections
            if (!formik.values.transporters || formik.values.transporters.length === 0) {
                formik.setFieldValue("transporters", formattedOptions);
            }
        }
    }
}, [transportQuoteDetailData]); // Runs when data changes


    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };
    const navigate = useNavigate()
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get("token");
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                let id = atob(b64id);
                if (token && id && user_id) {
                    dispatch(getTransportQuoteDetail(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }

    }, []);

    const formik = useFormik({
        initialValues: {
            transporters:[],
            quote_id: transportQuoteDetailData?.id,


        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {


            setDisableSubmitBtn(true);
            try {
                let config = { headers: { 'auth-token': Cookies.get('token'), 'user_id': user_id } }

                values.quote_id = transportQuoteDetailData?.id
              
                axios.post(`${adminMainUrl}/api/transport-quotation/bulk-mail`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            setDisableSubmitBtn(false);
                            toast.success(response?.data?.msg);


                        } else {
                            setDisableSubmitBtn(false);
                            toast.error(response?.data?.msg)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setDisableSubmitBtn(false);
                        let msg = "";
                        if (err.response) {
                            msg = err.response.data.msg;
                        } else {
                            msg = "Internal Server Error!"
                        };
                        toast.error(msg);
                    })
            } catch (error) {
                setDisableSubmitBtn(false);
                console.log(error);
                toast.error("Internal Server Error!")
            }
        }
    });

    
   
    return (
        <>
            <div className="page-wrapper">
                <form onSubmit={formik.handleSubmit}>
                    <FocusError formik={formik} />
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h4 className="page-title">Transporter Form</h4>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="card">

                            <div className="card-body">


                                <div className="main_detail_form mt-4">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">General information</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Company Name <span></span>
                                                </label>
                                                <p


                                                    className="form-control form-control-sm"

                                                >{transportQuoteDetailData?.full_name}</p>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Email <span></span>
                                                </label>
                                                <p


                                                    className="form-control form-control-sm"

                                                >{transportQuoteDetailData?.email}</p>

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Phone Number <span>*</span>
                                                </label>
                                                <p


                                                    className="form-control form-control-sm"

                                                >{transportQuoteDetailData?.phone}</p>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Pickup Date <span>*</span>
                                                </label>
                                                <p


                                                    className="form-control form-control-sm"

                                                >{transportQuoteDetailData?.pickup_date}</p>

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Delivery Date <span>*</span>
                                                </label>
                                                <p


                                                    className="form-control form-control-sm"

                                                >{transportQuoteDetailData?.delivery_date}</p>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
            <div className="ms-2">
                <label htmlFor="transporters" className="form-label mb-0">
                    Transporters
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                    <Select
                        className="custom-selector"
                        options={transporterOptions} // Dropdown options
                        name="transporters"
                        isMulti={true} // Allows multiple selections
                        isLoading={!transportQuoteDetailData?.transporters?.length} // Show loader if data is empty
                        isDisabled={false}
                        onChange={selectedOptions => {
                            const selectedTransporters = selectedOptions?.map(option => ({
                                id: option.value,
                                company_name: option.label,
                                email: option.email
                            })) || [];

                            formik.setFieldValue("transporters", selectedTransporters);
                        }}
                        value={formik.values.transporters?.map(selected => ({
                            value: selected.id,
                            label: selected.company_name,
                            email: selected.email
                        }))} // Ensures the selected options are set correctly
                    />
                </div>
            </div>
            {formik?.touched.transporters &&
                                    formik?.errors.transporters ? (
                                    <div className="error">
                                      {formik?.errors.transporters}
                                    </div>
                                  ) : null}
        </div>

                                    </div>


                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-2">
                                        <button
                                            className="btn btn-main-form me-md-2"
                                            type="submit"
                                            disabled={disableSubmitBtn}
                                        >
                                            {disableSubmitBtn ? <><i className="fas fa-spinner fa-spin"></i> Saving</> : "Create Quotation"}
                                        </button>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>
                </form >
            </div >
        </>
    )
}

export default TransporterPreview